import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var TrashcanSVG = function TrashcanSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M27,6H21.618L20.171,3.106A1.987,1.987,0,0,0,18.382,2H13.618a1.988,1.988,0,0,0-1.789,1.105L10.382,6H5A1,1,0,0,0,5,8H6V28a2.006,2.006,0,0,0,2,2H24a2.006,2.006,0,0,0,2-2V8h1a1,1,0,0,0,0-2ZM14,25a1,1,0,0,1-2,0V11a1,1,0,0,1,2,0Zm6,0a1,1,0,0,1-2,0V11a1,1,0,0,1,2,0ZM13.618,4h4.764l1,2H12.618Z"
  }));
};
TrashcanSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TrashcanSVG);